import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import registerServiceWorker, { unregister } from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root') as HTMLElement);

if (process.env.REACT_APP_REPEAT_SW_UNREG === 'true') {
  unregister();
} else {
  registerServiceWorker();
}




// WEBPACK FOOTER //
// ./src/index.tsx